/**
 * Curated set of 3D icons (Microsoft Fluent Emoji, MIT licensed) HR can pick
 * from for departments & teams. Image files live under `public/icons/3d/`.
 *
 * Kept separate from the picker component so that importing these constants
 * does not pull a React component into the module graph — a file that exports
 * both breaks Fast Refresh (react-refresh/only-export-components). The picker
 * lives in `@/components/DecorativeIconPicker`.
 */
export const ICON_OPTIONS: Record<string, string> = {
  building: "/icons/3d/building.png",
  wallet: "/icons/3d/wallet.png",
  users: "/icons/3d/users.png",
  cpu: "/icons/3d/cpu.png",
  heart: "/icons/3d/heart.png",
  laptop: "/icons/3d/laptop.png",
  wrench: "/icons/3d/wrench.png",
  megaphone: "/icons/3d/megaphone.png",
  factory: "/icons/3d/factory.png",
  briefcase: "/icons/3d/briefcase.png",
  graduation: "/icons/3d/graduation.png",
  globe: "/icons/3d/globe.png",
  award: "/icons/3d/award.png",
  shield: "/icons/3d/shield.png",
  rocket: "/icons/3d/rocket.png",
  target: "/icons/3d/target.png",
  truck: "/icons/3d/truck.png",
  package: "/icons/3d/package.png",
  headphones: "/icons/3d/headphones.png",
  code: "/icons/3d/code.png",
  camera: "/icons/3d/camera.png",
  star: "/icons/3d/star.png",
};

/** Suggests a default icon key based on a department's name. */
export function getDefaultDepartmentIconKey(name: string): string {
  const n = name.toLowerCase();
  if (n.includes("admin")) return "briefcase";
  if (n.includes("financ")) return "wallet";
  if (n.includes("hr") || n.includes("human")) return "users";
  if (n.includes("engineer") || n.includes("r&d")) return "cpu";
  if (n.includes("health") || n.includes("safety") || n.includes("hse")) return "heart";
  if (n.includes("it") || n.includes("tech")) return "laptop";
  if (n.includes("maintenance")) return "wrench";
  if (n.includes("marketing")) return "megaphone";
  if (n.includes("metal") || n.includes("automation") || n.includes("structure")) return "factory";
  return "building";
}

/** Resolves an icon key (possibly null/unknown) to an image path, with a fallback. */
export function resolveIcon(key: string | null | undefined, fallbackKey = "building"): string {
  return (key && ICON_OPTIONS[key]) || ICON_OPTIONS[fallbackKey] || ICON_OPTIONS.building;
}
